import { render, staticRenderFns } from "./animaux.vue?vue&type=template&id=408e5c9a"
import script from "./animaux.vue?vue&type=script&lang=js"
export * from "./animaux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports